import { MICROSOFT_ADS_API } from '@/shared/api/microsoftAds';
import { getMicrosoftAdsContext } from '@/shared/lib/microsoftAdsContext';
import { User } from '@/shared/types/User';

import { useSyncAdsContext } from './useSyncAdsContext';

export const useSyncMicrosoftAdsContext = (user?: User) => {
  useSyncAdsContext(user?.id, getMicrosoftAdsContext, MICROSOFT_ADS_API.saveContext);
};
